import logo from "../../assets/logo.png";
import { useSelector } from "react-redux";
import "./index.css";

const Loading = () => {
    const { loading, textLoading } = useSelector((state) => state.generic);

    if (!loading) return null;

    return (
        <div className="loading-container">
            <div className="loading-content">
                <img src={logo} alt={"Linea III"} className="loading-logo" />
                <p className="loading-text">{textLoading}</p>
            </div>
        </div>
    );
};

export default Loading;
